var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#55CD6C",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "whatsapp-(1)",
    transform: "translate(9.543529, 9.543529)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,28.9129412 L1.99397647,21.6847059 C0.69792,19.4414682 0,16.9489694 0,14.3567435 C0,6.48050824 6.48050824,0 14.4066071,0 C22.3327059,0 28.9129412,6.48050824 28.9129412,14.3567435 C28.9129412,22.2329788 22.3327624,28.9129412 14.4066071,28.9129412 C11.9141082,28.9129412 9.52133647,28.1153506 7.37776941,26.9189647 L0,28.9129412 Z",
    id: "Path",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77656471,24.3267388 L8.22522353,24.576 C10.0696659,25.7225224 12.2132329,26.4204424 14.4564706,26.4204424 C20.9867859,26.4204424 26.4204424,20.9867859 26.4204424,14.3567435 C26.4204424,7.72670118 20.9867859,2.49249882 14.4066071,2.49249882 C7.82642824,2.49249882 2.49249882,7.77656471 2.49249882,14.3567435 C2.49249882,16.6498447 3.14055529,18.8930824 4.33694118,20.7873882 L4.63606588,21.2360471 L3.48954353,25.4234541 L7.77656471,24.3267388 Z",
    id: "Path",
    fill: "#55CD6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5681882,7.67689412 L9.62106353,7.62703059 C9.32193882,7.62703059 9.02287059,7.72675765 8.82347294,7.92615529 C8.37481412,8.32495059 7.62708706,9.07267765 7.42768941,10.0697224 C7.07875765,11.5652329 7.62708706,13.3598118 8.9232,15.1543906 C10.2193129,16.9489694 12.7118118,19.8402635 17.09856,21.0865129 C18.4943435,21.4853082 19.5910588,21.2360471 20.4883765,20.6877176 C21.1862965,20.2390588 21.6348988,19.5411953 21.7844894,18.7934118 L21.9340235,18.0954918 C21.9838871,17.8960941 21.88416,17.6468329 21.6847624,17.5471624 L18.5442071,16.1015153 C18.3448094,16.0017882 18.0955482,16.0516518 17.9460141,16.2510494 L16.6997647,17.8462306 C16.6000376,17.9459576 16.4505035,17.9957647 16.3009694,17.9459576 C15.4535153,17.6468329 12.6120847,16.4504471 11.0667106,13.4594824 C11.0168471,13.3099482 11.0168471,13.1603576 11.1165741,13.0606871 L12.31296,11.7147671 C12.4126871,11.5652329 12.4624941,11.3658353 12.4126871,11.2162447 L10.96704,7.97601882 C10.91712,7.82642824 10.7675859,7.67689412 10.5681882,7.67689412",
    id: "Path",
    fill: "#FEFEFE"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b74715fde6c20bf0715ea6deea206f40.svg";
export { ForwardRef as ReactComponent };